import { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { ALL_APP_ROLES, AppRole } from "./roles";

type ClaimsWithRoles = {
  roles?: unknown;
  role?: unknown;
};

const knownRoles = new Set<string>(ALL_APP_ROLES);

const normalizeRoleClaims = (claimValue: unknown): AppRole[] => {
  const rawRoles = Array.isArray(claimValue)
    ? claimValue
    : typeof claimValue === "string"
      ? [claimValue]
      : [];

  return rawRoles.filter(
    (role): role is AppRole => typeof role === "string" && knownRoles.has(role)
  );
};

export const useRoles = () => {
  const { accounts, instance } = useMsal();
  const account = instance.getActiveAccount() || accounts[0];

  return useMemo(() => {
    const claims = account?.idTokenClaims as ClaimsWithRoles | undefined;
    const roles = normalizeRoleClaims(claims?.roles ?? claims?.role);
    return new Set<AppRole>(roles);
  }, [account?.idTokenClaims]);
};
